import styled from 'styled-components';

export const StyledEventTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  padding: 4px 6px;
  color: #333;
`;
